import type { Template } from "@/types";

export const LA_06_H4_V2: Template[] = [
    {
        id: "la-06-h4v2-01",
        name: "LA 01 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 96, y: 55, width: 484, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 362, width: 156, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 362, width: 156, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 362, width: 156, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 740, y: 55, width: 271, height: 420, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 55, width: 270, height: 420, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-02",
        name: "LA 02 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 95, y: 49, width: 481, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 95, y: 333, width: 237, height: 148, rotation: 0, imageRotation: 0 },
            { id: "3", x: 340, y: 333, width: 236, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 49, width: 298, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 271, width: 146, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 271, width: 145, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-03",
        name: "LA 03 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 153, y: 52, width: 170, height: 253, rotation: 0, imageRotation: 0 },
            { id: "2", x: 153, y: 312, width: 120, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 280, y: 312, width: 233, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 330, y: 52, width: 183, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 330, y: 183, width: 183, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 754, y: 84, width: 519, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-04",
        name: "LA 04 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 113, y: 40, width: 287, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 407, y: 272, width: 151, height: 219, rotation: 0, imageRotation: 0 },
            { id: "3", x: 407, y: 40, width: 151, height: 108, rotation: 0, imageRotation: 0 },
            { id: "4", x: 407, y: 156, width: 151, height: 108, rotation: 0, imageRotation: 0 },
            { id: "5", x: 836, y: 40, width: 355, height: 223, rotation: 0, imageRotation: 0 },
            { id: "6", x: 836, y: 271, width: 355, height: 222, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-05",
        name: "LA 05 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 85, y: 44, width: 290, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 271, width: 290, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 44, width: 290, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 271, width: 290, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 44, width: 289, height: 443, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 44, width: 289, height: 443, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-06",
        name: "LA 06 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 56, y: 44, width: 319, height: 219, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 271, width: 319, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 44, width: 289, height: 445, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 44, width: 319, height: 219, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 271, width: 319, height: 218, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 44, width: 290, height: 445, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-07",
        name: "LA 07 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 56, y: 44, width: 319, height: 219, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 271, width: 319, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 44, width: 289, height: 445, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 44, width: 290, height: 445, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 44, width: 319, height: 219, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 271, width: 319, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-08",
        name: "LA 08 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 35, y: 71, width: 256, height: 392, rotation: 0, imageRotation: 0 },
            { id: "2", x: 487, y: 71, width: 256, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 71, width: 567, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 298, y: 71, width: 182, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 298, y: 203, width: 182, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 298, y: 337, width: 182, height: 126, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-09",
        name: "LA 09 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 35, y: 71, width: 567, height: 392, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 71, width: 256, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 872, y: 71, width: 256, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1135, y: 71, width: 182, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1135, y: 203, width: 182, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1135, y: 337, width: 182, height: 126, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-10",
        name: "LA 10 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 166, y: 38, width: 641, height: 454, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 38, width: 154, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 270, width: 154, height: 223, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 38, width: 211, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 192, width: 211, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 976, y: 346, width: 211, height: 146, rotation: 0, imageRotation: 0 }
        ],
    }
];